import { render } from "./DeleteCohortModal.vue?vue&type=template&id=52cb6d90"
import script from "./DeleteCohortModal.vue?vue&type=script&lang=js"
export * from "./DeleteCohortModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__